import { render } from "./SoftwareView.vue?vue&type=template&id=67ad5596&scoped=true"
import script from "./SoftwareView.vue?vue&type=script&lang=js"
export * from "./SoftwareView.vue?vue&type=script&lang=js"

import "./SoftwareView.vue?vue&type=style&index=0&id=67ad5596&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67ad5596"]])

export default __exports__